import { chakra } from '@chakra-ui/react';
import React from 'react';

import { PERFORM_TYPES } from 'core/utils/constants';
import utils from 'core/utils/utils';

import { useFwAuth } from '../auth';
import { useFwSettings } from '../settings/useFwSettings';
import {
  containerStyle,
  glowStyle,
  green,
  red,
} from './FwLocalModeStatus.helpers';

// consider browser internet connection status instead of just local mode
// display a status indicator for network usage (green -> network access allowed ; red -> no network access allowed)
const FwLocalModeStatus = () => {
  const { user } = useFwAuth();
  const { localMode } = useFwSettings();

  return utils.canPerform(user, PERFORM_TYPES.local) ? (
    <chakra.span {...containerStyle}>
      <chakra.span
        {...glowStyle}
        bg={localMode ? red : green}
        boxShadow={
          localMode
            ? `0 0 10px ${red}, 0 0 20px ${red}, 0 0 30px ${red}`
            : `0 0 10px ${green}, 0 0 20px ${green}, 0 0 30px ${green}`
        }
      />
    </chakra.span>
  ) : null;
};

export default FwLocalModeStatus;
